export interface Option {
  readonly label: string
  readonly value: string
}

export const JOB_TYPE_OPTIONS: Option[] = [
  { value: "FULL_TIME", label: "Full time" },
  { value: "PART_TIME", label: "Part time" },
]

export const CONTRACT_TYPE_OPTIONS: Option[] = [
  { value: "INDETERMINATE", label: "Nedeterminată" },
  { value: "DETERMINATE", label: "Determinată" },
]

export const EXPERIENCE_OPTIONS: Option[] = [
  { value: "NO_EXPERIENCE", label: "Fara experienta" },
  { value: "ENTRY", label: "0-1 ani" },
  { value: "JUNIOR", label: "1-3 ani" },
  { value: "MID", label: "3-5 ani" },
  { value: "SENIOR", label: "5+ ani" },
]

export const WORK_LOCATION_TYPE_OPTIONS: Option[] = [
  { value: "AT_ADDRESS", label: "La adresă" },
  { value: "REMOTE", label: "Remote" },
  { value: "NOT_SPECIFIED", label: "Nu precizez" },
]

/** Pay unit shown in the UI, decoupled from the employment type (full/part time). */
export const PAY_UNIT_OPTIONS: Option[] = [
  { value: "MONTHLY", label: "Lună" },
  { value: "DAY", label: "Zi" },
  { value: "HOUR", label: "Oră" },
]

/** Gross/Net — only meaningful for a monthly salary. */
export const GROSS_NET_OPTIONS: Option[] = [
  { value: "GROSS", label: "Brut" },
  { value: "NET", label: "Net" },
]

/**
 * The backend stores a single `rateType` enum (HOUR/DAY/GROSS/NET).
 * In the UI we split it into a pay unit + (for monthly) a gross/net choice.
 */
export const payUnitFromRateType = (rateType: string): string => {
  if (rateType === "HOUR") return "HOUR"
  if (rateType === "DAY") return "DAY"
  if (rateType === "GROSS" || rateType === "NET") return "MONTHLY"
  return ""
}

export const grossNetFromRateType = (rateType: string): string =>
  rateType === "NET" ? "NET" : "GROSS"

/** Compose the backend `rateType` from the UI pay unit + gross/net choice. */
export const composeRateType = (payUnit: string, grossNet: string): string => {
  if (payUnit === "HOUR") return "HOUR"
  if (payUnit === "DAY") return "DAY"
  if (payUnit === "MONTHLY") return grossNet === "NET" ? "NET" : "GROSS"
  return ""
}

/** Short suffix used in the salary string (e.g. "30 RON /oră"). */
export const salaryUnitLabel = (rateType: string): string => {
  switch (rateType) {
    case "HOUR":
      return "/oră"
    case "DAY":
      return "/zi"
    case "GROSS":
      return "/lună brut"
    case "NET":
      return "/lună net"
    default:
      return ""
  }
}

export const labelForValue = (options: Option[], value: string): string =>
  options.find((o) => o.value === value)?.label ?? value
